import vitalConversion from '@/module/util/vital-conversion'
import BODYMAP from '@/module/util/get-bodymap'

// Number of symptoms to display before only showing the title
const ID_THRESHOLD = 5
const ID_TYPE = { symptom: true, vital: true }

export default function(patient, events) {
    var section = []
    var eventType = {}

    // Helpers for creating analysis objects
    var newAnalysis = (content, id) => ({ id, event: [], first: null, last: null, content })
    var addAnalysis = (analysis, event) => {
        analysis.event.push(event)
        if (analysis.first == null || analysis.first.time > (event.time || event.created))
            analysis.first = event
        if (analysis.last == null || analysis.last.time < (event.time || event.created))
            analysis.last = event
    }

    events.forEach((event) => {
        let typeId = event.type.split(':')
        let type = typeId[0]

        if (type == 'symptom' || type == 'vital') {
            let id = typeId[1]
            if (! eventType[type])
                eventType[type] = {}
            if (! eventType[type][id])
                eventType[type][id] = newAnalysis(type == 'symptom' ? this.getContent(type, id) : null, id)
            
            if(typeId[1] === 'sleep')
                event.value = event.sleep_end - event.sleep_start

            if (type == 'symptom')
                addAnalysis(eventType[type][id], event)
            else
                addAnalysis(eventType[type][id], {
                    type: event.type,
                    value: event.value,
                    unit: event.unit,
                    time: event.time,
                    created: event.created
                })
        }
        else {
            if (! eventType[type])
                eventType[type] = newAnalysis()
            addAnalysis(eventType[type], event)
        }
    })

    if (eventType.symptom)
        section.push(generateSymptom.call(this, patient, eventType.symptom))

    if (eventType.vital)
        section.push(generateVital.call(this, patient, eventType.vital))

    // if (eventType.food || eventType.water || eventType.excretion)
        // section.push(generateLifestyle.call(this, patient, eventType.food, eventType.water, eventType.excretion))

    return section.join('\n\n')
}

function totalAnalysis(analysisMap) {
    return Object.keys(analysisMap).map((a) => (analysisMap[a].event.length)).reduce((a, b) => (a + b), 0)
}

function generateSymptom(patient, symptom) {
    var result = [],
        totalSymptoms = Object.keys(symptom).length,
        firstSymptom = null,
        lastSymptom = null,
        total = totalAnalysis(symptom)

    // Iterate over all symptoms
    Object.keys(symptom).map((id) => {
        // Cache first and last symptom
        if (firstSymptom == null || symptom[id].first.time < firstSymptom.time)
            firstSymptom = symptom[id].first
        if (lastSymptom == null || symptom[id].last.time > lastSymptom.time)
            lastSymptom = symptom[id].last
    }).reduce((a, b) => (a + b), 0)

    result.push(patient.name, ' reported ')

    var ordered = Object.keys(symptom)
        .map((id) => symptom[id])
        .filter((s) => (s.content != null))
        .sort((a, b) => (b.event.length - a.event.length))

    ordered.forEach((orderedSymptom, i) => {
        let title = orderedSymptom.content.title.toUpperCase(),
            count = orderedSymptom.event.length

        if (i < ID_THRESHOLD) {
            result.push(`<b>${title}</b>`)
            if (orderedSymptom.event.length == 1)
                result.push(' 1 time on ' + this.formatDate(orderedSymptom.first.time, true), '; ')
            else
                result.push(' ', count, ' times between ', this.formatDate(orderedSymptom.first.time, true), ' and ', this.formatDate(orderedSymptom.last.time, true), '; ')
        }
        else if (i == ID_THRESHOLD) {
            result.push('They also recorded experiencing ')
        }
        if (i >= ID_THRESHOLD) {
            result.push(title, ' (', count, ' time', count == 1 ? '' : 's', '), ')
            if (i + 2 >= ordered.length)
                result.push('and ')
        }
    })

    // result.push('\n\n')
    // result.push('Symptom specifics: \n')

    // ordered.forEach((orderedSymptom, i) => {
    //     let title = orderedSymptom.content.title.toUpperCase(),
    //         count = orderedSymptom.event.length,
    //         id = orderedSymptom.id,
    //         analysis = {}
    //     orderedSymptom.event.forEach((e) => {
    //         if (Array.isArray(e.question)) {
    //             e.question.forEach((q) => {
    //                 if(!q)
    //                     return
    //                 else {
    //                     if (! analysis[q.question])
    //                         analysis[q.question] = {}
    //                     if (q.type == 'slider')
    //                         analysis[q.question][q.value] = (analysis[q.question][q.value] || 0) + 1
    //                     else if (Array.isArray(q.option)) {
    //                         q.option.forEach((o) => {
    //                             if(q.type === 'human_map')
    //                                 o = BODYMAP[o].name
    //                             analysis[q.question][o] = (analysis[q.question][o] || 0) + 1
    //                         })
    //                     }
    //                 }
                    
                        
    //             })
    //         }
    //     })

    //     result.push(title, ' (', count, ' time', count == 1 ? '' : 's', ') - ')

    //     let cq = orderedSymptom.content.question
    //     cq.forEach((q, i) => {
    //         let qa = analysis[q.question]
    //         if (qa && Object.keys(qa).length > 0) {
    //             result.push(q.title, ': ')
    //             Object.keys(qa).sort((a, b) => (qa[b] - qa[a])).forEach((k, i, keys) => {
    //                 result.push(k, ' (x', qa[k], ')')
    //                 if (i + 1 < keys.length)
    //                     result.push(', ')
    //                 else
    //                     result.push('. ')
    //             })
    //         }
    //     })
    //     result.push('\n')
    // })

    // result.push(patient.name, '  ')
    return result.join('')
}

function foodConversion(lifestyle, key) {
    if (key == 'size') {
        return { small: 1, medium: 2, large: 3 }[lifestyle.size]
    }
    if (key == 'health') {
        if (lifestyle.health == 'not healthy') return -1
        if (lifestyle.health == 'somewhat healthy') return 0
        if (lifestyle.health == 'very healthy') return 1
    }
    return null
}

const VITAL_ORDER = [
    'heart_rate',
    'body_weight',
    'body_temperature',
    'blood_pressure',
    'blood_glucose',
    'stress'
]

const VITAL_UNIT = {
    'heart_rate': ' beats/min',
    'body_weight': ' lb',
    'body_temperature': ' F',
    'blood_glucose': ' mg/dL',
    'stress': ''
}

const STRESS_VALUE = ['None', 'Normal', 'Moderate', 'Unbearable']

function generateVital(patient, vital) {
    var result = []
    var eventType = {},
        totalVitals = 0,
        firstVital = null,
        lastVital = null

    Object.keys(vital).forEach((id) => {
        vital[id].event.forEach((event) => {
            totalVitals++
            if (event.value != null)
                event.value = vitalConversion(event)
            if (firstVital == null || event.time > firstVital.time)
                firstVital = event
            if (lastVital == null || event.time < lastVital.time)
                lastVital = event
        })
    })

    var vitalTypes = Object.keys(vital).length
    // var firstVitalDate = this.formatDate(firstVital.time, true)
    // var lastVitalDate = this.formatDate(lastVital.time, true)

    result.push(patient.name, ' self recorded the following measures of their health:\n')
    // if (firstVitalDate == lastVitalDate)
    //     result.push(' on ', firstVitalDate + '. ')
    // else
    //     result.push(' between ', firstVitalDate, ' and ', lastVitalDate, '. ')

    VITAL_ORDER.forEach((id) => {
        if (vital[id] == null) return

        let name = id.split('_').map((n) => (
            n.substring(0, 1).toUpperCase() +
            n.substring(1))).join(' ')

        let count = vital[id].event.length
        let firstDate = this.formatDate(vital[id].first.time, true)
        let lastDate = this.formatDate(vital[id].last.time, true)

        result.push('<b>', name, '</b> - ', count, ' entr', count == 1 ? 'y' : 'ies', firstDate === lastDate ? ` on ${firstDate}, ` : ` between ${firstDate} and ${lastDate}, `)
        result.push(count == 1 ? ' which was ' : 'ranging from ')
        if (id == 'blood_pressure') {
            let systolic = vital[id].event.map((e) => e.value[0])
            let diastolic = vital[id].event.map((e) => e.value[1])
            let minSystolic = Math.min(...systolic)
            let maxSystolic = Math.max(...systolic)
            let minDiastolic = Math.min(...diastolic)
            let maxDiastolic = Math.max(...diastolic)

            result.push(' Systolic- <b> ')
            if (minSystolic == maxSystolic)
                result.push(minSystolic)
            else
                result.push(minSystolic, ' to ', maxSystolic)
            result.push(' mmHg</b>, Diastolic -<b> ')
            if (minDiastolic == maxDiastolic)
                result.push(minDiastolic)
            else
                result.push(minDiastolic, ' to ', maxDiastolic)
            result.push(' mmHg </b>')
        }
        else {
            let values = vital[id].event.map((e) => e.value)
            let minValue = Math.min(...values)
            let maxValue = Math.max(...values)

            if (id == 'stress') {
                minValue = STRESS_VALUE[Math.round(minValue)]
                maxValue = STRESS_VALUE[Math.round(maxValue)]
                if (minValue == maxValue)
                    result.push(' <b>', minValue, '</b>')
                else
                    result.push('<b>', minValue, ' to ', maxValue, '</b> ')
            }
            else if (minValue == maxValue)
                result.push(' <b>', minValue.toFixed(1), VITAL_UNIT[id], '</b> ')
            else
                result.push(' <b> ', minValue.toFixed(1), VITAL_UNIT[id], ' to ', maxValue.toFixed(1), VITAL_UNIT[id], '</b>')
        }
        result.push('\n')
    })

    return result.join('')
}

function generateLifestyle(patient, food, water, excretion) {

}
